import CheckboxTree from '@v7/form/src/components/Tools/Checkbox/CheckboxTree';
import DatePicker from '@v7/form/src/components/Tools/DatePicker';
import Input from '@v7/form/src/components/Tools/Input';
import RadioButtonGroup from '@v7/form/src/components/Tools/RadioButtonGroup';
import Select from '@v7/form/src/components/Tools/Select';
import Text from '@v7/form/src/components/Tools/Text';
import TextArea from '@v7/form/src/components/Tools/TextArea';
import File from '@v7/form/src/components/Tools/File';
import Button from '@v7/form/src/components/Button';
import Image from '@v7/form/src/components/Tools/Image';
import PhotoCapture from '@v7/form/src/components/Tools/PhotoCapture';
import SectionGroup from '@v7/form/src/components/Tools/SectionGroup';
import Video from '@v7/form/src/components/Tools/Video';
import PhoneNumber from '@v7/form/src/components/Tools/PhoneNumber';
import { customBlocksTypes } from '@v7/form/src/components/Tools/CustomBlocks/utils';

export const getElement = (type: string, id?: string) => {
  switch (type) {
    case customBlocksTypes.input:
      return <Input type="text" labelSize="sm" />;
    case customBlocksTypes.number:
      return <Input type="number" labelSize="sm" />;
    case customBlocksTypes.email:
      return <Input type="email" labelSize="sm" />;
    case customBlocksTypes.checkbox:
      return <CheckboxTree />;
    case customBlocksTypes.radio:
      return <RadioButtonGroup />;
    case 'text':
      return <Text />;
    case customBlocksTypes.datepicker:
      return <DatePicker />;
    case customBlocksTypes.select:
      return <Select labelKey="label" primaryKey="value" isDisabled isClearable isSearchable />;
    case customBlocksTypes.textarea:
      return <TextArea labelSize="sm" />;
    case customBlocksTypes.file:
      return <File />;
    case customBlocksTypes.image:
      return <Image />;
    case customBlocksTypes.video:
      return <Video {...({} as unknown as React.ComponentProps<typeof Video>)} />;
    case customBlocksTypes.photoCapture:
      return <PhotoCapture />;
    case customBlocksTypes.sectionStart:
      return <SectionGroup />;
    case customBlocksTypes.sectionEnd:
      return <SectionGroup type={customBlocksTypes.sectionEnd} />;
    case customBlocksTypes.phoneNumber:
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- preview-only render, required props not applicable
      return <PhoneNumber {...({} as any)} />;
    case 'button':
      return <Button />;
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment -- must stay a valid cloneable React element: callers (renderHelpers.tsx, CreateBlock.tsx, Block/index.tsx) call React.cloneElement() on this return value unconditionally, and cloneElement(null, ...) throws
      return <></>;
  }
};
